import React, { useEffect, useState } from "react";
import { ujmsOrg } from "../../services/ujmsApi";
import { Panel, thCls, tdCls, cls } from "../ui";

const ENTITIES = [
  ["jurisdictions", "Jurisdictions"], ["circuits", "Circuits"], ["counties", "Counties"],
  ["judicial-departments", "Judicial Departments"],
  ["divisions", "Divisions"], ["districts", "Districts"], ["courthouses", "Courthouses"],
  ["courtrooms", "Courtrooms"], ["agencies", "Agencies"], ["departments", "Departments"],
  ["judicial-officers", "Judicial Officers"], ["calendars", "Calendars"],
];

export default function UjmsOrg() {
  const [entity, setEntity] = useState("divisions");
  const [rows, setRows] = useState([]);

  useEffect(() => { ujmsOrg(entity).then((r) => setRows(r.data)).catch(() => setRows([])); }, [entity]);

  const cols = rows.length
    ? Object.keys(rows[0]).filter((k) => !["id", "created_at", "updated_at", "deleted_at"].includes(k) && !k.endsWith("_id"))
    : [];

  return (
    <div className="space-y-4" data-testid="ujms-org">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Court Organization</h1>
        <p className="text-sm text-slate-500">The structural backbone: jurisdiction → circuit → county → divisions/districts → courthouses → courtrooms, plus agencies and the judicial roster.</p>
      </div>
      <div className="flex flex-wrap gap-1">
        {ENTITIES.map(([key, label]) => (
          <button key={key} onClick={() => setEntity(key)} data-testid={`org-tab-${key}`}
            className={cls("text-xs font-semibold uppercase tracking-wide px-3 py-1.5 border rounded-sm",
              entity === key ? "bg-blue-900 text-white border-blue-900" : "bg-white text-slate-600 border-slate-300 hover:bg-slate-100")}>
            {label}
          </button>
        ))}
      </div>
      <Panel testId="org-table">
        <table className="w-full border-collapse">
          <thead><tr>{cols.map((c) => <th key={c} className={thCls}>{c.replace(/_/g, " ")}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-slate-50">
                {cols.map((c) => <td key={c} className={tdCls}>{typeof r[c] === "object" ? JSON.stringify(r[c]) : String(r[c] ?? "—")}</td>)}
              </tr>
            ))}
            {!rows.length && <tr><td className={tdCls}>No records.</td></tr>}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
